import axios from 'axios';
import store from '@/store/index'

const instance = axios.create({
  baseUrl: '',      // 请求地址
  timeOut: 60000,   // 请求超时设置
  headers: {"Accept": "application/json"},
});

//测试例子
export const getUserInfo = params => {
  return instance.get(`/xxx/xxx`, params);
  // store.commit('userInfo/saveUserInfo',{name: '小v', phone: '123'});
};


// WEBPACK FOOTER //
// ./src/request/index.js